import { parseWindowView, WindowView } from './model/presenter-url'

/**
 * What this window is, decided once from its address when the bundle loads:
 * the store is built for it (`window-store.ts`), and the presentation window
 * never mounts the joining code. A window does not change role while it lives.
 */
export const WINDOW_VIEW: WindowView =
	typeof window === 'undefined'
		? { role: 'host' }
		: parseWindowView(window.location.search)
